import React, { useState, useEffect } from 'react';
import jwtDecode from 'jwt-decode';
import { Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import { WaveLoading } from 'react-loadingg';
import moment from 'moment';
import axios from 'axios';
import XLSX from 'xlsx';

import { PageTitle, SimplePopup } from 'components';

import { StatisticsToolbar, StatisticsTable } from './components';

import { IsNoU } from 'common/utils';

import { toast } from 'react-toastify';

import serverURI from 'config/URI';

// >> redux
import {
  getCompanyNames,
  getCarNumbers,
} from '../../redux/actions/companies';
// <<

// >> redux
import {
  getAgencies,
  getClients,
} from 'redux/actions/companies';
// <<


// >> redux
import {
  getAreas,
  getGroups,
} from 'redux/actions/manage';
// <<


// >> redux
import {
  getStatistics,
  addStatistic,
  updateStatistic,
  findAdvertiseLogs,
  removeAdvertiseLogs,
  deleteAllAdvertiseLogs,
  findTaxiLogs,
  removeTaxiLogs,
  deleteAllTaxiLogs,
  findClientLogs,
} from 'redux/actions/statistics';
// <<

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
  row: {
    height: '82px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    marginTop: theme.spacing(2)
  },
  appBar: {
    position: 'relative',
  },
  title: {
    marginLeft: theme.spacing(2),
    flex: 1,
  },
}));

const Statistics = (props) => {
  const classes = useStyles();

  const { type } = props.match.params;

  const { 
    statistics, 
    statistics_total,
    advertiseLogs,
    taxiLogs,
    clientLogs,
    loading, 
    loading_find_statistics,

    company_names,
    car_numbers,
    agencies,
    clients,
    areas,
    groups,
  } = props;

  const [userId, setUserId] = useState(null);
  const [userName, setUserName] = useState(null);
  const [userRole, setUserRole] = useState(null);
  
  const [find_data, set_find_data] = useState({});

  const [find_type, set_find_type] = useState(0);

  const [selectedAgency, setSelectedAgency] = useState('');
  const [selectedClient, setSelectedClient] = useState('');

  const [agencyClients, setAgencyClients] = useState([]);
  const handleChangeAgency = e => {
    let newAgencyClients = clients.filter(client => client.agency === e.target.value);
    //console.log('new agency clients ->');
    //console.log(newAgencyClients);
    setAgencyClients(newAgencyClients);
    setSelectedClient('');
    setSelectedAgency(e.target.value);
  };

  const handleChangeClient = event => {
    setSelectedClient(event.target.value);
  };

  const handleFindLogs = (findType, startDate, endDate, 
    advertise,
    agency,
    client,
    area,
    group,
    template,
    ad_type,
    company,
    car_number,
    on_taxi) => {

    //console.log(findType + ',' + startDate + ',' + endDate);

    let find = {
      type: findType, 
    }

    if (findType !== 0) 
    {
      find.start_date = startDate;
      find.end_date = endDate;
    }

    //console.log('find.on_taxi -> ' + on_taxi);
    if (type === 'advertise') {
      if (advertise) find.advertise = advertise;
      if (agency && agency !== '전체') find.agency = agency;
      if (client && client !== '전체') find.client = client;
      if (area && area !== '전체') find.area = area;
      if (group && group !== '전체') find.group = group;
      if (template && template !== '전체') find.template = template;
      if (ad_type && ad_type !== '전체') find.ad_type = ad_type;
      if (company && company !== '전체') find.company = company;
      if (car_number && car_number !== '전체') find.car_number = car_number;
    }
    else if (type === 'taxi') {

      if (company && company !== '전체') find.company = company;
      if (car_number && car_number !== '전체') find.car_number = car_number;

      if (!IsNoU(on_taxi) && on_taxi !== '전체') {
        find.on_taxi = on_taxi;
      }
      //console.log('find.on_taxi -> ' + find.on_taxi);
    }
    else if (type === 'client') {
      find.start_date = startDate;
      find.end_date = endDate;

      if (agency && agency !== '전체') find.agency = agency;
      if (client && client !== '전체') find.client = client;
    }

    find.page = 0;
    find.rows_per_page = rowsPerPage;
    setPage(0);

    set_find_data(find);

    //console.log(find);

    if (type === 'advertise')
      props.findAdvertiseLogs(find);
    else if (type === 'taxi') {
      //if (findType === 2 && on_taxi) find.on_taxi = on_taxi;
      props.findTaxiLogs(find);
    }
    else if (type === 'client') {
      props.findClientLogs(find);
    }
  }

  const [selectedDeleteStartDate, setSelectedDeleteStartDate] = useState(new Date());
  const [selectedDeleteEndDate, setSelectedDeleteEndDate] = useState(new Date());

  const handleDeleteLogs = () => {

    setDeleteAlertMsg('일괄삭제 하시겠습니까 ?');
    setOpenDeleteAlert(true);

  }

  const [deleteAlertMsg, setDeleteAlertMsg] = useState('');
  const [openDeleteAlert, setOpenDeleteAlert] = useState(false);

  const handleClickCloseDeleteAlert = () => {
    setOpenDeleteAlert(false);
  }
  const handleClickDeleteAlertOk = () => {

    const deleteDate = {
      start_date : selectedDeleteStartDate, 
      end_date : selectedDeleteEndDate
    }

    if (type === 'advertise')
      props.deleteAllAdvertiseLogs(deleteDate);
    else if (type === 'taxi')
      props.deleteAllTaxiLogs(deleteDate);

    setOpenDeleteAlert(false);
  }

  const handleDownloadStatisticFile = async () => {
    let download_url = '';
    if (type === 'advertise')
      download_url = `${serverURI}/api/statistics/advertise/download`;
    else if (type === 'taxi')
      download_url = `${serverURI}/api/statistics/taxi/download`;
    else if (type === 'client')
      download_url = `${serverURI}/api/statistics/client/download`;

    const res = await axios.post(download_url, find_data);
    console.log(res);
    let excel_datas = [];
    var wscols = [];
    let sheet_name = '';

    const dateNow = new Date();
    let fileName = 'report_excel';

    if (type === 'advertise') {
      const logs = res.data.logs;
      excel_datas = logs.map(log => {
        let excel_data = {};
        if (find_type === 2) {
          excel_data = {
            '광고명' : log.name,
            '템플릿' : log.template,
            '광고유형' : log.type === 'normal' ? '유료' : '무료',
            '광고대행사' : log.agency,
            '광고주' : log.client,
            '권역' : log.area,
            '그룹' : log.group,
            '택시회사명' : log.company,
            '차량번호' : log.car_number,
            '재생일시' : log.log_at && moment(log.log_at).format('YYYY-MM-DD HH:mm:ss')
          };
        }
        else {
          excel_data = {
            '광고명' : log.name,
            '템플릿' : log.template,
            '광고유형' : log.type === 'normal' ? '유료' : '무료',
            '광고대행사' : log.agency,
            '광고주' : log.client,
            '권역' : log.area,
            '그룹' : log.group,
            '택시회사명' : log.company,
            '차량번호' : log.car_number,
            '재생횟수' : log.log_count && log.log_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회'
          };
        }
        return excel_data;
      });

      sheet_name = '광고재생로그';

      wscols = [
        {wch:20},
        {wch:16},
        {wch:16},
        {wch:16},
        {wch:16},
        {wch:16},
        {wch:16},
        {wch:16},
        {wch:16},
        {wch:20},
      ];

      fileName = `report_advertise_log_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }
    else if (type === 'taxi') {
      const logs = res.data.logs;
      console.log(logs);
      excel_datas = logs.map(log => {
        let excel_data = {};
        if (find_type === 2) {
          excel_data = {
            '택시회사명' : log.company,
            '차량번호' : log.car_number,
            '승/하차' : log.event === 'get_on' ? '승차' : 
                       log.event === 'get_off' ? '하차' :
                       log.event,
            '생성일시' : log.log_at && moment(log.log_at).format('YYYY-MM-DD HH:mm:ss'),
          };
        }
        else {
          excel_data = {
            '택시회사명' : log.company,
            '차량번호' : log.car_number,
            '승/하차' : log.event === 'get_on' ? '승차' : 
                       log.event === 'get_off' ? '하차' :
                       log.event,
            '횟수' : log.log_count && log.log_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회',
          };
        }
        return excel_data;
      });

      sheet_name = '택시승하차로그';

      wscols = [
        {wch:20},
        {wch:20},
        {wch:16},
        {wch:20},
      ];

      fileName = `report_taxi_log_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }
    else if (type === 'client') {
      const results = res.data.logs;
      excel_datas = results.map(log => {
        return {
          '광고대행사명' : log.agency,
          '광고주명' : log.client,
          '광고명' : log.name,
          '템플릿' : log.template,
          '광고유형' : log.type,
          '광고기간' : log.start_date && log.end_date ? moment(log.start_date).format('YYYY-MM-DD') + '~' + moment(log.end_date).format('YYYY-MM-DD') : '' ,
          '전체뷰카운트' : log.view_count ? log.view_count.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'회' : '0회',
          '계약금액' : log.cost ? log.cost.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")+'원' : '0원',
          '등록자' : log.modified_user,
          '등록일' : log.modified_at ? moment(log.modified_at).format('YYYY-MM-DD HH:mm:ss') : '',
        };
      });

      sheet_name = '광고사별광고현황';

      wscols = [
        {wch:20},
        {wch:20},
        {wch:30},
        {wch:10},
        {wch:10},
        {wch:26},
        {wch:16},
        {wch:16},
        {wch:10},
        {wch:20},
      ];

      fileName = `report_agency_client_log_${dateNow.getFullYear()}_${dateNow.getMonth()+1}_${dateNow.getDate()}_${dateNow.getHours()}_${dateNow.getMinutes()}_${dateNow.getSeconds()}`;
    }

    const new_workbook = XLSX.utils.book_new(); // excel 파일에 해당 
    const worksheet = XLSX.utils.json_to_sheet(excel_datas); // excel sheet하단의 worksheet에 해당 
    worksheet['!cols'] = wscols;

    XLSX.utils.book_append_sheet(new_workbook, worksheet, sheet_name); // excelsheet를 excel파일에 넣음 
    XLSX.writeFile(new_workbook, fileName + '.xlsx');
  }

  const handleClickOpenDownload = () => {
    if ((type === 'advertise' && advertiseLogs.length === 0)
      || (type === 'taxi' && taxiLogs.length === 0)
      || (type === 'client' && clientLogs.length === 0))
      {
        toast('검색 정보가 없습니다.');
        return ;
      }
    handleDownloadStatisticFile();
  };

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [page, setPage] = useState(0);

  const handlePageChange = (event, page) => {
    setPage(page);
    if (type === 'advertise') {
      let find_page_data = find_data;
      find_page_data.page = page;
      set_find_data(find_page_data);

      props.findAdvertiseLogs(find_page_data);
    }
    else if (type === 'taxi') {
      let find_page_data = find_data;
      find_page_data.page = page;
      set_find_data(find_page_data);

      props.findTaxiLogs(find_page_data);
    }
    else if (type === 'client') {
      let find_page_data = find_data;
      find_page_data.page = page;
      set_find_data(find_page_data);

      props.findClientLogs(find_page_data);
    }
  };

  const handleRowsPerPageChange = e => {
    let rows_per_page = e.target.value;
    setRowsPerPage(rows_per_page);
    setPage(0);
    if (type === 'advertise') {
      let find_page_data = find_data;
      find_page_data.page = 0;
      find_page_data.rows_per_page = rows_per_page;

      set_find_data(find_page_data);

      props.findAdvertiseLogs(find_page_data);
    }
    else if (type === 'taxi') {
      let find_page_data = find_data;
      find_page_data.page = 0;
      find_page_data.rows_per_page = rows_per_page;
      set_find_data(find_page_data);

      props.findTaxiLogs(find_page_data);
    }
    else if (type === 'client') {
      let find_page_data = find_data;
      find_page_data.page = 0;
      find_page_data.rows_per_page = rows_per_page;
      set_find_data(find_page_data);

      props.findClientLogs(find_page_data);
    }
  };

  useEffect(() => {
    //console.log("componentDidMount");

    props.getCompanyNames();
    props.getCarNumbers();
    props.getAgencies();
    props.getClients();
    props.getAreas();
    props.getGroups();

    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      const decoded = jwtDecode(jwt);

      if (decoded.userid !== null) {
        setUserId(decoded.userid);
      }
      if (decoded.name !== null) {
        setUserName(decoded.name);
      }
      if (decoded.role !== null) {
        setUserRole(decoded.role);
      }
    }

    return () => {
      //console.log("componentDidUnmount");
      props.removeAdvertiseLogs();
      props.removeTaxiLogs();
    };
  }, []); // empty-array means don't watch for any updates

  useEffect(() => {
    //console.log('componentDidUpdate & type changed');
    setPage(0);
    if (type !== 'advertise') props.removeAdvertiseLogs();
    if (type !== 'taxi') props.removeTaxiLogs();

  }, [type]);

  useEffect(() => {
    //console.log('componentDidUpdate & type changed');
    setPage(0);
    props.removeAdvertiseLogs();
    props.removeTaxiLogs();
 
  }, [find_type]);

  if (loading) {
    return <WaveLoading />;
  }
  
  return (
    <div className={classes.root}>

      {type !== 'advertise' && type !== 'taxi' && type !== 'client' && <Redirect to="/not-found"/>}

      <PageTitle
        pageTitle={
          type === 'advertise'? '광고재생 로그' : 
          type === 'taxi'? '택시승하차 로그' : 
          '광고사별광고현황'
        }
        />

      <StatisticsToolbar 
        userRole={userRole}
        type={type}
        find_type={find_type}
        set_find_type={set_find_type}
        onClickFindLogs={handleFindLogs}
        onClickDeleteLogs={handleDeleteLogs}

        selectedDeleteStartDate={selectedDeleteStartDate}
        setSelectedDeleteStartDate={setSelectedDeleteStartDate}
        selectedDeleteEndDate={selectedDeleteEndDate}
        setSelectedDeleteEndDate={setSelectedDeleteEndDate}
        
        company_names={company_names}
        car_numbers={car_numbers}
        // agencies={[{id:-1, name: '전체'}, ...agencies]}
        // clients={[{id:-1, name: '전체'}, ...clients]}
        agencies={[{id:-1, name: '전체'}, ...agencies]}
        clients={[{id:-1, name: '전체'}, ...agencyClients]}
        selectedAgency={selectedAgency}
        onChangeAgency={handleChangeAgency}
        selectedClient={selectedClient}
        //onSetSelectedClient={client => setSelectedClient(client)}
        onChangeClient={handleChangeClient}
        areas={[{id:-1, name: '전체'}, ...areas]}
        groups={[{id:-1, name: '전체'}, ...groups]}
        />

      <div className={classes.content}>
        <StatisticsTable 
          type={type}
          find_type={find_type}
          statistics={statistics}
          advertiseLogs={advertiseLogs}
          taxiLogs={taxiLogs}
          clientLogs={clientLogs}

          onClickOpenDownloadDialog={handleClickOpenDownload}
          
          openProgress={loading_find_statistics}
          page={page}
          rowsPerPage={rowsPerPage}
          item_total={statistics_total}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          />
      </div>

      <SimplePopup
        title={deleteAlertMsg} 
        openPopup={openDeleteAlert} 
        onClickClose={handleClickCloseDeleteAlert} 
        onClickOk={handleClickDeleteAlertOk}
        />
    </div>
  );
};

//export default Statistics;

Statistics.propTypes = {
  loading: PropTypes.bool,
  statistics: PropTypes.arrayOf(PropTypes.object),
  advertiseLogs: PropTypes.arrayOf(PropTypes.object),
  taxiLogs: PropTypes.arrayOf(PropTypes.object),

  agencies: PropTypes.arrayOf(PropTypes.object),
  clients: PropTypes.arrayOf(PropTypes.object),
  areas: PropTypes.arrayOf(PropTypes.object),
  groups: PropTypes.arrayOf(PropTypes.object),
};

Statistics.defaultProps = {
  loading: false,
  statistics: [],
  advertiseLogs: [],
  taxiLogs: [],

  agencies: [],
  clients: [],
  areas: [],
  groups: [],
};

const mapStateToProps = state => ({
  loading: state.statistics.loading,
  loading_find_statistics: state.statistics.find_statistics_loading,
  statistics: state.statistics.statisticList,
  advertiseLogs: state.statistics.advertiseLogList,
  taxiLogs: state.statistics.taxiLogList,
  clientLogs: state.statistics.clientLogList,
  statistics_total: state.statistics.statistics_total,

  company_names: state.companies.companyNameList,
  car_numbers: state.companies.carNumberList,
  agencies: state.companies.reged_agencyList,
  clients: state.companies.reged_clientList,
  areas: state.manage.reged_areaList,
  groups: state.manage.groupList,
});

const mapDispatchToProps = dispatch => ({
  getStatistics: () => {getStatistics(dispatch)},
  addStatistic: (statistic) => {addStatistic(statistic, dispatch)},
  updateStatistic: (id, statistic) => {updateStatistic(id, statistic, dispatch)},
  // deleteStatistics: (deletes) => {deleteCar(deletes, dispatch)},

  findAdvertiseLogs: (find) => {findAdvertiseLogs(find, dispatch)},
  removeAdvertiseLogs: () => {removeAdvertiseLogs(dispatch)},
  deleteAllAdvertiseLogs: (deleteDate) => {deleteAllAdvertiseLogs(deleteDate, dispatch)},

  findTaxiLogs: (find) => {findTaxiLogs(find, dispatch)},
  removeTaxiLogs: () => {removeTaxiLogs(dispatch)},
  deleteAllTaxiLogs: (deleteDate) => {deleteAllTaxiLogs(deleteDate, dispatch)},

  findClientLogs: (find) => {findClientLogs(find, dispatch)},

  getCompanyNames: () => {getCompanyNames(dispatch)},
  getCarNumbers: () => {getCarNumbers(dispatch)},
  getAgencies: () => {getAgencies(dispatch)},
  getClients: () => {getClients(dispatch)},
  getAreas: () => {getAreas(dispatch)},
  getGroups: () => {getGroups(dispatch)},  
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Statistics);

